export default __webpack_public_path__ + "static/media/Reveal-view.1f8a47f2.svg";